import { COMPONENT_TABLE_NAME } from 'constants/index';

const { QUESTIONS, BASE_TESTS, TESTS, RESULTS, VERIFICATION } = COMPONENT_TABLE_NAME;

export const accessToButtons = {
  addNewButtonAccess: [TESTS, QUESTIONS, BASE_TESTS],
  clearButtonAccess: [RESULTS, QUESTIONS, TESTS, BASE_TESTS, VERIFICATION],
};
